import instance from "./axios";
import { SiliconEntryType } from "../types/Silicon";
import { PostSiliconPayload } from "../types/Silicon";

export const fetchLastSilicon = async (): Promise<SiliconEntryType[]> => {
  const response = await instance.get<SiliconEntryType[]>(
    "/v1.0/Material/GetLastSilicon?num=6"
  );
  return Array.isArray(response.data) ? response.data : [response.data];
};

export async function postSilicon(
  data: PostSiliconPayload,
  operatorId: number
) {
  const payload = {
    operatorid: String(operatorId),
    stationid: 36,
    dateInProduction: new Date().toISOString().replace(".000Z", "+02:00"),
    siliconBatch: data.batchNumber,
    expiryDate: data.expirationDate,
  };

  return instance.post("/v1.0/Material/AddSilicon", payload);
}

export const fetchSiliconLoader = async () => {
  try {
    const entries = await fetchLastSilicon();
    return {
      title: "Silicon-Erfassung",
      entries,
    };
  } catch (error: any) {
    console.error(error.message || "Fehler beim Laden der Silicon-Daten");
    throw new Response("Silicon-Daten konnten nicht geladen werden", {
      status: 500,
    });
  }
};
